export * from './activity';
export * from './address';
export * from './after-sale';
export * from './app';
export * from './auth';
export * from './comment';
export * from './commodity';
export * from './coupon';
export * from './custom';
export * from './distributorCenter';
export * from './forum';
export * from './gift';
export * from './integralSignin';
export * from './order';
export * from './placeOrder';
export * from './resource';
export * from './search';
export * from './subscribe';
export * from './user';
export * from './membershipLevel';

import { createPinia } from 'pinia';

const pinia = createPinia();

export default pinia;
